import clothesInfoReducer from "./reducers";
export { default as clothesInfoTypes } from "./types";
export { default as clothesInfoOperations } from "./operations";
export default clothesInfoReducer;
